import React from 'react';

import styles from './KodeLogo.module.css';
import { KODE_PATHS, KODE_VIEWBOX } from './paths';

// Логотип нарисован контурами прямо в SVG: закрытый контур QA не пускает
// внешние шрифты и картинки с CDN. currentColor подхватывает цвет тулбара.
// Сами контуры лежат в paths.js — их разделяет с KodeWelcome.
const kodeLogo = (props) => (
    <div className={styles.Logo}>
        <svg
            viewBox={KODE_VIEWBOX}
            height={props.height}
            role="img"
            aria-label="KODE"
            focusable="false"
        >
            <g fill="currentColor" fillRule="nonzero">
                {KODE_PATHS.map((pathData) => (
                    <path key={pathData.slice(0, 16)} d={pathData} />
                ))}
            </g>
        </svg>
    </div>
);

export default kodeLogo;
